import { createRoute } from '@tanstack/react-router';

import { RootRoute } from '$/routes/RootRoute';

export const EditorRouteLayout = createRoute({
  getParentRoute: () => RootRoute,
  id: 'editorLayout',
});
